
const it = {
  // Navigation
  'navigation.home': 'Home',
  'navigation.music': 'Musica',
  'navigation.about': 'Chi Sono',
  'navigation.videos': 'Video',
  'navigation.contact': 'Contatto',

  // Home page
  'home.hero_title_1': 'JEAN-CLAUDE',
  'home.hero_title_2': 'BASTOS',
  'home.hero_subtitle': 'POTENZA ELETTRONICA UK',
  'home.hero_description': 'Creando tracce ad alta energia con un tocco cinematografico',
  'home.cta_experience': 'VIVI IL SUONO',
  'home.cta_connect': 'CONNETTITI',
  'home.latest_releases': 'ULTIME USCITE',
  'home.latest_releases_subtitle': 'TRACCE ELETTRONICHE AD ALTA ENERGIA CON TOCCO CINEMATOGRAFICO',
  'home.track_1_title': 'Break the Ground',
  'home.track_1_desc': 'PROGRESSIVE HOUSE ESPLOSIVA CON DROP DEVASTANTI',
  'home.track_2_title': 'Running Free',
  'home.track_2_desc': 'INNO ESTIVO CON MELODIE EUFORICHE ED EDIFICANTI',
  'home.track_3_title': 'When We Loved',
  'home.track_3_desc': 'VIAGGIO MELODICO EMOTIVO CON BREAKDOWN AMBIENT',
  'home.about_title_1': 'PRODUTTORE MUSICALE',
  'home.about_title_2': 'ELETTRONICO UK',
  'home.about_text_1': 'Jean-Claude Bastos è una potenza elettronica basata nel Regno Unito che crea tracce ad alta energia con un tocco cinematografico. Combina elementi di progressive house, techno melodica e breakdown ispirati all\'ambient.',
  'home.about_text_2': 'Il suo suono è progettato per muovere sia le folle che le cuffie, adatto sia agli appassionati di musica elettronica che alle playlist notturne.',
  'home.cta_discover': 'SCOPRI IL VIAGGIO',
  'home.quote': 'Le mie canzoni preferite sono sempre sembrate CARTOLINE DA LUOGHI dove non sono mai stato. Questo è quello che cerco di creare—COLONNE SONORE PER LUOGHI che esistono solo quando chiudi gli occhi.',
  'home.quote_author': '— JEAN-CLAUDE BASTOS',
  'home.final_cta_title': 'VIVI IL SUONO',
  'home.final_cta_subtitle': 'ESPLORA IL SUONO. SENTI LA COSTRUZIONE. UNISCITI AL VIAGGIO.',
  'home.cta_listen': 'ASCOLTA ORA',
  'home.cta_website': 'SITO UFFICIALE',

  // About page
  'about.hero_title': 'Chi Sono',
  'about.hero_subtitle': 'La storia dietro la musica e il viaggio di Jean-Claude Bastos',
  'about.main_title': 'Jean-Claude Bastos',
  'about.main_text_1': 'Jean-Claude Bastos è un produttore di musica elettronica basato nel Regno Unito che crea tracce ad alta energia con un tocco cinematografico. Combina elementi di progressive house, techno melodica e breakdown ispirati all\'ambient, il suo suono progettato per muovere sia i fan della musica elettronica che le cuffie.',
  'about.main_text_2': 'Con uscite precoci come Running Free, Break the Ground e When We Loved, Bastos ha rapidamente costruito una reputazione per produzioni immersive ed energia versatile — perfette per gli appassionati di musica elettronica e le playlist notturne.',
  'about.main_text_3': 'Che tu stia scoprendo i suoi beat per la prima volta o seguendo ogni nuovo drop, questo viaggio rappresenta il centro ufficiale per tutto ciò che riguarda Jean-Claude Bastos. Esplora il suono. Senti la costruzione. Unisciti al viaggio.',
  'about.music_style': 'Stile Musicale',
  'about.music_style_desc': 'Progressive House, Techno Melodica & Breakdown Ambient',
  'about.based_in': 'Basato In',
  'about.based_in_desc': 'Regno Unito',
  'about.quote': 'I beat sono come colori per me – ogni melodia dipinge un nuovo stato d\'animo. La mia musica dovrebbe catturare momenti che non possono essere conservati con le foto, solo con i suoni.',
  'about.quote_author': '– DJ Jean-Claude Bastos',
  'about.journey_title': 'Viaggio Musicale',
  'about.journey_subtitle': 'Dalle prime ispirazioni alle uscite rivoluzionarie',
  'about.journey_1_title': 'Primi Inizi',
  'about.journey_1_desc': 'Iniziato con una passione per paesaggi sonori emotivi che trasportano gli ascoltatori in nuovi mondi',
  'about.journey_2_title': 'Uscite Rivoluzionarie',
  'about.journey_2_desc': 'Running Free, Break the Ground e When We Loved hanno stabilito il suo suono unico nella scena della musica elettronica',
  'about.journey_3_title': 'Visione Futura',
  'about.journey_3_desc': 'Continua a spingere i confini con produzioni immersive ed esperienze elettroniche cinematografiche',
  'about.website_cta_title': 'Visita il Sito Ufficiale',
  'about.website_cta_desc': 'Per accesso esclusivo a nuova musica, link di streaming, contenuti video e approfondimenti dietro le quinte nel processo creativo di Jean-Claude.',

  // Contact page
  'contact.hero_title': 'Contatto',
  'contact.hero_subtitle': 'Per richieste stampa, collaborazioni o semplicemente per connettersi',
  'contact.get_in_touch': 'Mettiti in Contatto',
  'contact.location_title': 'Posizione',
  'contact.location_desc': '📍 Regno Unito',
  'contact.email_title': 'Email',
  'contact.email_desc': '📧 Disponibile tramite modulo di contatto',
  'contact.specialization_title': 'Specializzazione',
  'contact.specialization_desc': 'Progressive House • Techno Melodica • Produzione Musicale Elettronica',
  'contact.website_title': 'Sito Ufficiale',
  'contact.follow_title': 'Segui il Viaggio',
  'contact.form_title': 'Invia un Messaggio',
  'contact.form_name': 'Nome Completo *',
  'contact.form_name_placeholder': 'Il tuo nome completo',
  'contact.form_email': 'Indirizzo Email *',
  'contact.form_email_placeholder': 'tua.email@esempio.com',
  'contact.form_message': 'Messaggio * (max. 500 caratteri)',
  'contact.form_message_placeholder': 'Dimmi della tua richiesta stampa, idee di collaborazione o semplicemente saluta...',
  'contact.form_characters': 'caratteri',
  'contact.form_sending': 'Invio in corso...',
  'contact.form_send': 'Invia Messaggio',
  'contact.form_success': 'Grazie! Il tuo messaggio è stato inviato con successo.',
  'contact.form_error': 'Errore nell\'invio del messaggio. Riprova.',
  'contact.services_title': 'Focus Creativo',
  'contact.services_subtitle': 'Creazione e produzione di musica elettronica ad alta energia',
  'contact.service_1_title': 'Produzione Musicale',
  'contact.service_1_desc': 'Tracce elettroniche ad alta energia progettate per muovere sia le folle che le cuffie, con tocco cinematografico',
  'contact.service_2_title': 'Sound Design',
  'contact.service_2_desc': 'Esperienze audio immersive con elementi di techno melodica e progressive house',
  'contact.service_3_title': 'Collaborazioni Creative',
  'contact.service_3_desc': 'Lavorando con altri artisti e produttori per progetti musicali elettronici innovativi',

  // Music page
  'music.hero_title': 'Musica',
  'music.hero_subtitle': 'Scopri le ultime uscite e tracce di Jean-Claude Bastos',
  'music.latest_releases': 'ULTIME USCITE',
  'music.more_tracks': 'PIÙ TRACCE',
  'music.play_on': 'Riproduci su',
  'music.duration': 'Durata',

  // Videos page
  'videos.hero_title': 'Video',
  'videos.hero_subtitle': 'Video musicali e contenuti creativi di Jean-Claude Bastos',
  'videos.music_videos': 'Video Musicali',
  'videos.official_content': 'Video musicali ufficiali e contenuti visivi di Jean-Claude Bastos',
  'videos.subscribe_youtube': 'Iscriviti su YouTube',
  'videos.watch_youtube': 'Guarda su YouTube',
  'videos.views': 'Visualizzazioni',
  'videos.duration': 'Durata',
  'videos.stay_connected': 'Rimani Connesso',
  'videos.subscribe_message': 'Iscriviti al canale YouTube per contenuti esclusivi e ultime uscite',
  'videos.subscribe_now': 'Iscriviti Ora',
  'videos.listen_music': 'Ascolta la Musica',

  // Footer
  'footer.made_with': 'Fatto con',
  'footer.rights': 'Tutti i diritti riservati.',

  seo: {
    title: 'Jean-Claude Bastos | DJ UK & Produttore EDM',
    description: 'Jean-Claude Bastos è un DJ e produttore EDM con base nel Regno Unito che porta beat ad alta energia e inni estivi ai fan di tutto il mondo. Scopri la sua musica, i mix e le ultime uscite.',
    keywords: 'Jean-Claude Bastos, DJ UK, Produttore EDM, Electronic Dance Music, Progressive House, Break the Ground, Running Free, When We Loved, musica elettronica UK, artista EDM, produttore musica elettronica',
    home: {
      title: 'Jean-Claude Bastos | Produttore Musica Elettronica UK & DJ',
      description: 'Vivi il mondo elettrizzante di Jean-Claude Bastos, la sensazione di musica elettronica emergente del Regno Unito. Tracce EDM ad alta energia, beat progressive house ed esperienze elettroniche cinematografiche. Ascolta Break the Ground, Running Free e When We Loved.',
      keywords: 'Jean-Claude Bastos, musica elettronica UK, produttore EDM, progressive house, Break the Ground, Running Free, When We Loved, DJ UK, electronic dance music'
    },
    music: {
      title: 'Musica | Jean-Claude Bastos - Ultime Tracce EDM & Uscite Elettroniche',
      description: 'Esplora il catalogo musicale completo di Jean-Claude Bastos. Ascolta in streaming e scopri le ultime tracce EDM inclusi Break the Ground, Running Free, When We Loved e altri inni progressive house.',
      keywords: 'Jean-Claude Bastos musica, tracce EDM, progressive house, uscite musica elettronica, Break the Ground, Running Free, When We Loved, musica elettronica UK'
    },
    videos: {
      title: 'Video Musicali | Jean-Claude Bastos - Video Musica Elettronica Ufficiali',
      description: 'Guarda i video musicali ufficiali di Jean-Claude Bastos inclusi Break the Ground, Running Free, When We Loved e Firestarter Hearts. Contenuti video di musica elettronica di alta qualità.',
      keywords: 'Jean-Claude Bastos video, video musica elettronica, video Break the Ground, video Running Free, video When We Loved, video musicali EDM, musica elettronica UK'
    },
    about: {
      title: 'Chi è Jean-Claude Bastos | Biografia Produttore Musica Elettronica UK',
      description: 'Scopri di più su Jean-Claude Bastos, il produttore di musica elettronica basato nel Regno Unito che crea tracce ad alta energia con tocco cinematografico. Scopri il suo viaggio musicale, stile e visione artistica.',
      keywords: 'Jean-Claude Bastos biografia, produttore musica elettronica UK, artista progressive house, techno melodica, biografia musica elettronica, background DJ UK'
    },
    contact: {
      title: 'Contatta Jean-Claude Bastos | Richieste Produttore Musica Elettronica',
      description: 'Contatta Jean-Claude Bastos per richieste stampa, collaborazioni musicali, prenotazioni e opportunità commerciali. Contatta il produttore di musica elettronica UK oggi.',
      keywords: 'Jean-Claude Bastos contatto, contatto produttore musica elettronica, prenotazione DJ UK, collaborazione musicale, richieste stampa, contatto produttore EDM'
    }
  }
};

export default it;
